import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import ApiClientUI from './ApiClientUI';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ApiClientUI />
  </React.StrictMode>
);
